import React from 'react';
import { useSelector } from 'react-redux';

import { Form, Select } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

import CreatableSelect from 'react-select/creatable';

import _ from 'underscore';

const initialState = {
  isLoading: true,
  selectedEntities: null,
  name: '',
  company_name: '',
  address: '',
  pic_name: '',
  pic_phone: '',
  pic_email: '',
  finance_name: '',
  finance_phone: '',
  optionsEmails: [],
};

const entitiesOptions = [
  { value: 'community', label: 'Community' },
  { value: 'personal', label: 'Personal' },
  { value: 'corporate', label: 'Corporate' },
  { value: 'instansi', label: 'Instansi' },
];

export const FormBulkUpdate = ({ data, onSubmit, onClose }) => {
  const StateForm = useSelector((state) => state.Form);
  const dummy = Array.from({ length: 6 }, (v, i) => i);

  const [
    {
      isLoading,
      selectedEntities,
      name,
      company_name,
      address,
      pic_name,
      pic_phone,
      pic_email,
      optionsEmails,
      finance_name,
      finance_phone,
    },
    setState,
  ] = React.useState(initialState);

  const $onSave = async (c) => {
    let emails = []

    _.each(optionsEmails, (i) => {
      emails.push(i?.label)
    })

    const payload = {
      name,
      company_name,
      address,
      pic_name,
      pic_phone,
      pic_email,
      finance_emails: emails,
      finance_name,
      finance_phone,
      type: 'customer',
      entities: selectedEntities?.value || '',
    };

    onSubmit(payload);
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, [isLoading]);

  React.useEffect(() => {
    if (!data) return;
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));

    const entities =
      data?.entities === 'community'
        ? entitiesOptions[0]
        : data?.entities === 'personal'
        ? entitiesOptions[1]
        : data?.entities === 'corporate'
        ? entitiesOptions[2]
        : data?.entities === 'instansi'
        ? entitiesOptions[3]
        : null;

    let oe = []
    if (data?.finance_emails) {
      _.each(data?.finance_emails, (i) => {
        oe.push({label: i, value: i})
      })
    }

    setState((prevState) => ({
      ...prevState,
      selectedEntities: entities,
      name: data?.name,
      company_name: data?.company_name,
      address: data?.address,
      pic_name: data?.pic_name,
      pic_phone: data?.pic_phone,
      pic_email: data?.pic_email,
      finance_name: data?.finance_name,
      finance_phone: data?.finance_phone,
      optionsEmails: oe,
    }));
  }, [data]);

  if (isLoading) {
    return (
      <div className="row m-0">
        {dummy?.map((d, i) => (
          <div className="col-md-6">
            <SkeletonsForm count={1} key={i} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="px-3 pt-4 pb-3 bg-white my-3 border rounded-2">
      <div className="row text-start">
        <div className="col-12">
          <div className="hr-text hr-text-left text-primary mb-3 ">
            Perbaharui
          </div>
        </div>
        <div className="col-12">
          <div className="mb-3">
            <label className='form-label required'>Entities</label>
            <Select
              isClearable
              classNamePrefix={
                StateForm?.errors?.pricing_schema ? 'is-invalid' : 'select'
              }
              placeholder=""
              value={selectedEntities}
              options={entitiesOptions}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  selectedEntities: e,
                }))
              }
              error={StateForm?.errors?.entities}
            />

            {StateForm?.errors?.entities ? (
              <div className="invalid-feedback" style={{ display: 'block' }}>
                {StateForm?.errors?.entities}
              </div>
            ) : null}
          </div>
          <Form.Input
            required
            label="Nama Customer"
            type="text"
            value={name}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                name: e.target.value,
              }))
            }
            error={StateForm?.errors?.name}
          />
          <Form.Input
            label="Nama Perusahaan"
            type="text"
            value={company_name}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                company_name: e.target.value,
              }))
            }
            error={StateForm?.errors?.company_name}
          />
          <Form.Textbox
            label="Alamat Lengkap"
            rows={4}
            value={address}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                address: e.target.value,
              }))
            }
            error={StateForm?.errors?.address}
          />
        </div>

        <div className="col-md-6">
          <div className="pt-2 mb-3">
            <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
              Data Penanggung Jawab
            </div>
            <div className="pt-3">
              <Form.Input
                required
                label="Nama Penanggung Jawab"
                type="text"
                value={pic_name}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    pic_name: e.target.value,
                  }))
                }
                error={StateForm?.errors?.pic_name}
              />
              <Form.Input
                required
                label="Nomor HP Penanggung Jawab"
                type="phone"
                value={pic_phone}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    pic_phone: e.target.value,
                  }))
                }
                error={StateForm?.errors?.pic_phone}
              />
              <Form.Input
                label="Email Penanggung Jawab"
                type="email"
                value={pic_email}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    pic_email: e.target.value,
                  }))
                }
                error={StateForm?.errors?.pic_email}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="pt-2 mb-3">
            <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
              Data Finance
            </div>

            <div className="pt-3">
              <Form.Input
                label="Nama Finance"
                type="text"
                value={finance_name}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    finance_name: e.target.value,
                  }))
                }
                error={StateForm?.errors?.finance_name}
              />
              <Form.Input
                label="Nomor HP Finance"
                type="phone"
                value={finance_phone}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    finance_phone: e.target.value,
                  }))
                }
                error={StateForm?.errors?.finance_phone}
              />
              <div className="mb-3">
                <label className='form-label'>Email Finance</label>
                <CreatableSelect
                  value={optionsEmails}
                  classNamePrefix={StateForm?.errors?.finance_emails ? 'is-invalid' : 'select'}
                  placeholder="Enter Emails"
                  style={{backgroundColor: 'rgba(42,255,0,0.3 )'}}
                  className="bg-white"
                  isMulti
                  onChange={(e) =>
                    setState((prevState) => ({
                      ...prevState,
                      optionsEmails: e,
                    }))
                  }
                />

                {StateForm?.errors?.finance_emails ? (
                  <div className="invalid-feedback" style={{ display: 'block' }}>
                    {StateForm?.errors?.finance_emails}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end align-items-center gap-3 border-top mt-4 pt-3 mb-0">
        <div
          className="btn btn-primary btn-sm rounded-2 px-5 "
          onClick={$onSave}
        >
          Simpan Perubahan
        </div>
        <div className="btn btn-danger btn-sm rounded-2 px-5" onClick={onClose}>
          Batal
        </div>
      </div>
    </div>
  );
};
